import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowUpRight } from "lucide-react";
import { api, inr, CONTACT } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentSuccess() {
  const { orderId } = useParams();
  const { user } = useAuth();
  const [p, setP] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.get(`/payments/${orderId}`).then((r) => setP(r.data ?? null)).catch(() => setErr(true));
  }, [orderId]);

  return (
    <main className="min-h-screen px-5 pt-36 pb-20 sm:px-8" data-testid="payment-success-page">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mx-auto max-w-2xl rounded-3xl border border-white/10 bg-[#0E1526] p-8 sm:p-12">
        {err ? (
          <p className="text-slate-300" data-testid="payment-not-found">We couldn't find this order. Please contact us on +91 {CONTACT.phone}.</p>
        ) : !p ? (
          <p className="text-slate-400">Loading…</p>
        ) : (
          <>
            <CheckCircle2 className="h-12 w-12 text-[#00F0FF]" />
            <h1 className="mt-6 font-display text-4xl font-bold text-white sm:text-5xl" data-testid="payment-status">
              {p.status === "paid" ? "Payment successful." : "Payment pending."}
            </h1>
            <p className="mt-3 text-slate-300">Thank you! We'll call you within one working day to start your {p.plan.toLowerCase()}.</p>
            <dl className="mt-8 space-y-3 border-t border-white/10 pt-6 text-sm">
              <div className="flex justify-between gap-4"><dt className="text-slate-400">Amount</dt><dd className="font-mono text-white" data-testid="payment-amount">{inr(p.amount)}</dd></div>
              <div className="flex justify-between gap-4"><dt className="text-slate-400">Plan</dt><dd className="text-white">{p.plan}</dd></div>
              <div className="flex justify-between gap-4"><dt className="text-slate-400">Payment ID</dt><dd className="font-mono text-white">{p.payment_id || "—"}</dd></div>
              <div><dt className="text-slate-400">Services</dt><dd className="mt-2 text-white">{p.services.join(", ")}</dd></div>
            </dl>
            <div className="mt-10 flex flex-wrap gap-3">
              <Link to={user ? "/dashboard" : "/"} data-testid="payment-continue-button" className="group flex items-center gap-2 rounded-full bg-[#00F0FF] px-6 py-3 font-semibold text-[#070B14]">
                {user ? "Go to dashboard" : "Back to home"} <ArrowUpRight className="h-4 w-4 transition-transform group-hover:rotate-45" />
              </Link>
              <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="payment-whatsapp-link" className="rounded-full border border-white/20 px-6 py-3 text-white hover:border-[#00F0FF]">WhatsApp us</a>
            </div>
          </>
        )}
      </motion.div>
    </main>
  );
}
